<template>
  <div>
    <v-card-text >
      <v-alert value="true" type="warning">Для того чтобы отключить колонтитулы при печати из браузера Mozilla Firefox
        нужно открыть основное меню браузера,
        выбрать «Печать» — «Параметры страницы»: В окне программы «Параметры страницы» переходим на вкладку «Поля и
        колонтитулы»,
        в которой в разделе «Колонтитулы» выбираем «пусто» из выпадающих списков настроек:
      </v-alert>
      <v-btn @click="print()" class="primary">Напечатать</v-btn>
    </v-card-text>

    <v-layout subheading row wrap class="align-center hiddenPlace noLayout">
      <p class="pl-5">Председатель диссертационного совета:</p>
      <v-flex
        pl-4
        md1
      >
        <v-text-field
          v-model="headofSoviet[0]"
          label="En"
          placeholder="Belyakov A.V."
        ></v-text-field>
      </v-flex>
      <v-flex
        pl-4
        md1
      >
        <v-text-field
          v-model="headofSoviet[1]"
          label="Ru"
          placeholder="Беляков А.В."
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout subheading row wrap class="align-center hiddenPlace noLayout">
      <p class="pl-5">Номер приказа:</p>
      <v-flex
        pl-4
        md1
      >
        <v-text-field
          v-model="NumOfOrder[0]"
          label="En"
        ></v-text-field>
      </v-flex>
      <v-flex
        pl-4
        md1
      >
        <v-text-field
          v-model="NumOfOrder[1]"
          label="Ru"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout subheading row wrap class="align-center hiddenPlace noLayout">
      <p class="pl-5">Номер протокола:</p>
      <v-flex
        pl-4
        md1
      >
        <v-text-field
          v-model="NumOfProtocol"
          label="№"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <div class="initialField" v-if="param && industry && speciality" >
        <div id="printJS-form" class="printField">
          <div class="leftdivside">
            <div class="ma-d1">
              <p class="script1 md1head hiddenPlace">
                    According tp the decision<br>
                    of the Academic Degree Council<br>
                    of Dmitry Mendeleev University<br>
                    of Chemical Technology of Russia
              </p>
              <p class="script1 md1head md1-p2">
                {{ param.dissertationCouncil.replace('У', 'Y') }} <br>
                {{ param.protectionDate[0] }} {{NumOfProtocol}}
              </p>
            </div>
            <div class="ma-d2">
              <span class="script2 md2fio">
                {{ param.fio.en[0] }} </br> {{ param.fio.en[1] }}
              </span>
            </div>
            <div class="ma-d3">
              <span class="script1 md3s1 hiddenPlace">IS AWARDED THE ACADEMIC DEGREE OF</span><br>
              <span class="script1 md3s2 hiddenPlace">DOCTOR OF PHILOSOPHY (Ph.D)</span>
              <div class="divbr_average"></div>
              <div>
                <span class="md3-d2 script2 md3s3">
                  {{ industry[0] }}
                </span>
              </div>
              <div style="height: 1mm"></div>
              <div class="md3-d4">
                <span class="script2 md3s4">
                  {{ speciality[0] }}
                </span>
              </div>
            </div>
            <div class="ma-d4">
              <div class="md4l1">
                <span class="script1">
                  Chairperson<br>of the Academic Degree Council
                </span>
                <div class="divbr_large"></div>
                <span class="script1 mdlr1-sp2">{{ headofSoviet[0] }}</span>
              </div>
              <div class="md4l2">
                <span class="script1">Rector</span><br>
                <span class="script1">of Dmitry Mendeleev University</span>
                <div class="divbr_large"></div>
                <span class="script1">Majouga A.G.</span>
              </div>
            </div>
            <div class="ma-d5">
              <p style="text-align: left;">
                <span class="script1 hiddenPlace">Series&emsp;&emsp;</span>
                <span class="script1 md5sb hiddenPlace">AK №&emsp;&emsp;000000</span>
                <span class="script1 hiddenPlace">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;seal</span><br>
                <div class="md5-d1">
                  <span class="script1 md5-sp4">
                    Order of {{ param.rectorOrderDate[0] }} № {{ NumOfOrder[0] }}
                  </span>
                </div>
              </p>
            </div>
            <p class="script1 lastp hiddenPlace">MOSCOW</p>
          </div>
          <div class="rightdivside">
            <div class="ma-d1">
              <p class="script1 md1head hiddenPlace">
                    Решением совета по защите диссертаций<br>
                    на соискание ученой степени кандидата наук<br>
                    на соискание ученой степени доктора наук<br>
                    РХТУ им. Д.И. Менделеева
              </p>
              <p class="script1 md1head md1-p2">
                {{ param.dissertationCouncil }} <br>
                {{ param.protectionDate[1]}}{{NumOfProtocol}}
              </p>
            </div>
            <div class="ma-d2">
              <p class="script2 md2fio">
                {{ param.fio.ru }}
              </p>
            </div>
            <div class="ma-d3">
              <span class="script1 md3s1 hiddenPlace">ПРИСУЖДЕНА УЧЕНАЯ СТЕПЕНЬ</span><br>
              <span class="script1 md3s2 hiddenPlace" >КАНДИДАТА</span>
              <div class="divbr_average"></div>
              <div>
                <span class="md3-d2 script2 md3s3">
                  {{ industry[1] }}
                </span>
              </div>
              <div style="height: 1mm"></div>
              <div class="md3-d4">
                <span class="script2 md3s4">
                  {{ speciality[1] }}
                </span>
              </div>
            </div>
            <div class="ma-d4">
              <div class="md4l1">
                <span class="script1">Председатель<br>диссертационного совета</span>
                <div class="divbr_large"></div>
                <span class="script1 mdlr1-sp2">{{ headofSoviet[1] }}</span>
              </div>
              <div class="md4l2">
                <span class="script1">Ректор</span><br>
                <span class="script1">РХТУ им. Д.И. Менделеева</span>
                <div class="divbr_large"></div>
                <span class="script1">Мажуга А.Г.</span>
              </div>
            </div>
            <div class="ma-d5">
              <p>
                <span class="script1 hiddenPlace">Серия&emsp;&emsp;</span>
                <span class="script1 md5sb hiddenPlace">АК №&emsp;&emsp;000000</span>
                <span class="script1 hiddenPlace">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;&ensp;М.П.</span><br>
                <div class="md5-d1">
                  <span class="script1 md5-sp4">
                    Приказ от {{ param.rectorOrderDate[1] }} года № {{ NumOfOrder[1] }}
                  </span>
                </div>
              </p>
            </div>
            <p class="script1 lastp hiddenPlace">МОСКВА</p>
          </div>
          <qrcode :value="createQRcode()" :options="{ width: 88 }" class="qr"></qrcode>
        </div>
    </div>
  </div>
</template>

<script>
  import {makeGetRequest} from "@/helper";
  import urls from "@/modules/petition/urls";

  export default {
    name: "PrintQr",
    data() {
      return {
        output: null,
        item: null,
        param: null,
        industry: null,
        speciality: null,
        headofSoviet: ['Belyakov A.V.', 'Беляков А.В'],
        NumOfOrder: ['', ''],
        NumOfProtocol: '№ _',
      }
    },
    created() {
      this.loadData()
    },
    methods: {
      createQRcode() {
        return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + this.$router.resolve({name: 'QRPage',}).href
      },
      print() {
        window.print();
      },
      loadData() {
        this.loading = true
        let url = process.env.VUE_APP_API_HOST + "council/public/case/models/candidate_case/" + this.$route.params.uid + "/"

        if (this.$route.params.uid === undefined)
          this.$router.push({name: 'PageNotFound'})
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.item = json
          this.param = {}

          this.param.rectorOrderNumber = this.item.rectorOrderNumber
          this.param.rectorOrderDate = []
          var nowDate = new Date(this.item.rectorOrderDate)
          this.param.rectorOrderDate.push(nowDate.toLocaleDateString('en-us',
            {year: 'numeric', month: 'long', day: 'numeric'}))
          this.param.rectorOrderDate.push(nowDate.toLocaleDateString('ru',
            {year: 'numeric', month: 'long', day: 'numeric'}).slice(0, -3))

          this.NumOfOrder[0] = this.param.rectorOrderNumber
          this.NumOfOrder[1] = this.param.rectorOrderNumber

          this.param.fio = {}
          this.param.fio.en = [this.item.lastName[1].text,
            this.item.firstName[1].text]
          this.param.fio.ru = [this.item.lastName[0].text,
            this.item.firstName[0].text, ].join(' ')
          if(this.item.patronymic !== null)
            this.param.fio.ru= this.param.fio.ru + ' '+this.item.patronymic[0].text
          this.param.dissertationCouncil = this.item.dissertationCouncil.code

          nowDate = new Date(this.item.protectionDate)
          this.param.protectionDate = []
          var order_words = nowDate.toLocaleDateString('en-us',{year: 'numeric', month: 'long', day: 'numeric'})
            .replace(',', '').split(' ')
          this.param.protectionDate.push([order_words[1], order_words[0], order_words[2]].join(' '))
          this.param.protectionDate.push('от ' + nowDate.toLocaleDateString('ru',
            {year: 'numeric', month: 'long', day: 'numeric'}).slice(0, -3) + ' г.')

          this.loadScientificField()

          this.loading = false
        })
      },
      loadScientificField() {
        let urlsci = new URL(urls.getUrl(this.item.scientificField.url_name, this.item.scientificField.action))
        let params = this.item.scientificField.get_params
        urlsci.search = new URLSearchParams(params).toString();
        let sys = true
        makeGetRequest(urlsci).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          this.industry = []
          this.industry.push('in ' + json.results[0].scientificField.scientificIndustry.name[1].text)
          this.industry.push(json.results[0].scientificField.scientificIndustry.name[0].text.toLowerCase().slice(0, -1)
            + 'х наук')
          this.speciality = []
          this.speciality.push(['Scientific Speciality', json.results[0].scientificField.scientificSpecialty.code,
            json.results[0].scientificField.scientificSpecialty.name[1].text].join(' '))
          this.speciality.push(['по научной специальности', json.results[0].scientificField.scientificSpecialty.code,
            json.results[0].scientificField.scientificSpecialty.name[0].text].join(' '))
        })
      }
    }
  }
</script>

<style scoped>
@import "~../../../../../../public/css/certprint.css";
.theme--light.application {
  color: rgba(4,0,0,.87);
}
</style>
